import type { PrivateEvent } from '../../api/privateEvents';

import NotRecordedPill from './NotRecordedPill';
import { eventLocation, LOCATION_TBD } from './privateEventDisplay';

/**
 * The location cell's content, shared by the table row and the phone card so
 * the two can't drift into telling different stories about where an event is
 * happening. Renders only the inner content — the card and the row each keep
 * their own wrapping element (a `div` vs. a `td`).
 */
export default function PrivateEventLocationCell({
  event,
  short = false,
}: {
  event: PrivateEvent;
  short?: boolean;
}) {
  if (event.locationKind === 'unrecorded')
    return <NotRecordedPill field="Location" short={short} />;
  if (event.locationKind === 'tbd') {
    return <span style={{ fontStyle: 'italic', color: 'var(--nb-muted)' }}>{LOCATION_TBD}</span>;
  }
  const location = eventLocation(event);
  if (location) {
    return (
      <>
        <span style={{ fontWeight: 700, color: 'var(--nb-ink)' }}>{location.primary}</span>
        {location.subline && <div style={{ fontSize: 11 }}>{location.subline}</div>}
      </>
    );
  }
  return null;
}
